module.exports = __webpack_public_path__ + "media/images/likes-501422b5c7b843f7d9fea73c5b99fcb9.jpg";